import Routing from '~/pages/routing'
import withProviders from './providers'
import './styles/index.css'
import './locale/i18n'
import ForbiddenPage from '~/pages/forbidden'
import { useForbiddenErrorListener } from '~/entities/forbidden/hooks/use-forbidden-error-listener'
import HealthCheck from '~/entities/health-check/model'
import VersionUpdateNotifier from './version-update-notifier'
import { CapsLockObserver } from '~/features/delivery/shipping-order-by-id/model/caps-lock'
import DemoEnvironmentIndicator from './demo-environment-indicator'

const App = () => {
  const { hasForbiddenError, text } = useForbiddenErrorListener()

  if (hasForbiddenError) {
    return <ForbiddenPage text={text} />
  }

  return (
    <>
      <DemoEnvironmentIndicator />
      <VersionUpdateNotifier />
      <HealthCheck />
      <CapsLockObserver />
      <Routing />
    </>
  )
}

export default withProviders(App)
